import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let PrivacyOption: LazyOption = createLazyOption(
    {
        key: 'search',
        titleStringKey: 'option_privacy_searchHistory',
        searchTermsStringKey: 'option_privacy_searchHistory',
        isHidden: () => !isFeatureEnabled('sea-gdpr'),
    },
    lazyFullModule,
    m => m.default
);
export default PrivacyOption;
